var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"login_page"}},[_vm._m(0),_c('section',{attrs:{"id":"login_page_body"}},[_c('signin')],1),_c('section',{attrs:{"id":"login_page_footer"}},[_vm._v(" Copyright © 2024 Thinkninnovation. All Rights Reserved. ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"login_page_header"}},[_c('img',{attrs:{"src":require("@/assets/images/logo.png")}})])
}]

export { render, staticRenderFns }